import React, { lazy, memo } from 'react';
import { Route, Routes } from 'react-router-dom';
const MyProfile = lazy(() => import('../controllers/ProfileRevamp/MyProfile'));
const PublicMyProfile = lazy(() => import('../controllers/ProfileRevamp/PublicMyProfile/PublicMyProfile'));
const FOF = lazy(() => import('../controllers/FOF'));
const Billing = lazy(() => import('../controllers/Billing'));
const Plans = lazy(() => import('../controllers/Plans'));
const Profile = lazy(() => import('../controllers/Profile'));
const Dashboard = lazy(() => import('../controllers/Dashboard'));
const Support = lazy(() => import('../controllers/Support'));
const Interviews = lazy(() => import('../controllers/Interviews'));
const MainPage = lazy(() => import('../controllers/MainPage'));
const RouteLists = memo(() => {
    return (
        <Routes>
            {RoutesFile?.map((itm, key) => (
                <Route
                    key={key}
                    path={itm?.path}
                    exact={itm?.exact}
                    element={<MainPage Component={itm?.component} />}
                />
            ))}
            <Route path="*" element={<FOF />} />
        </Routes>
    );
});

const RoutesFile = [
    {
        path: '/dashboard',
        exact: true,
        name: 'Dashboard',
        component: Dashboard,
    },
    {
        path: '/interviews',
        exact: true,
        name: 'My Interview',
        component: Interviews,
    },
    {
        path: '/profile',
        exact: true,
        name: 'My Profile',
        component: MyProfile,
    },
    {
        path: '/mock-profile/public-profile/:profileId',
        exact: true,
        name: 'Public Profile',
        component: PublicMyProfile,
    },
    {
        path: '/billings',
        exact: true,
        name: 'AccountsBilling',
        component: Billing,
    },
    {
        path: '/plans',
        exact: true,
        name: 'Plans & Pricing',
        component: Plans,
    },
    {
        path: '/support',
        exact: true,
        name: 'Support',
        component: Support,
    },
    {
        path: '/profile-settings',
        exact: true,
        name: 'Settings',
        component: Profile,
    },
];

export default RouteLists;
